import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const scenes = [
  {
    title: "🍬 Candy Collector",
    emoji: "🍬",
    count: 30,
    zone1: { label: "🐼 Panda", percent: 10 },
    zone2: { label: "🐯 Tiger", percent: 30 },
    hint: "10% = one-tenth! So 10% of 30 = 3 🍬"
  },
  {
    title: "🍬 Candy Collector",
    emoji: "🍬",
    count: 50,
    zone1: { label: "Crocodile", percent: 10 },
    zone2: { label: "Lion", percent: 30 },
    hint: "10% = one-tenth! So 10% of 50 = 5 🍬"
  },
  {
    title: "🍬 Candy Collector",
    emoji: "🍬",
    count: 60,
    zone1: { label: "Seahorse", percent: 10 },
    zone2: { label: "Clown fish", percent: 30 },
    hint: "10% = one-tenth! So 10% of 60 = 6 🍬"
  },
  {
    title: "🍎 Fruit Feast",
    emoji: "🍎",
    count: 40,
    zone1: { label: "🐵 Monkey", percent: 25 },
    zone2: { label: "🦊 Fox", percent: 50 },
    hint: "25% = one fourth! 50% = half 🍎"
  },
  {
    title: "🎂 Birthday Cake Time",
    emoji: "🎂",
    count: 20,
    zone1: { label: "🐻 Bear", percent: 50 },
    zone2: { label: "🦉 Owl", percent: 25 },
    hint: "50% = half, 25% = quarter of 20 🎂"
  }
];

const PercentFunParty = () => {
  const [currentScene, setCurrentScene] = useState(0);
  const [zone1Answer, setZone1Answer] = useState('');
  const [zone2Answer, setZone2Answer] = useState('');
  const [result, setResult] = useState('');

  const scene = scenes[currentScene];

  useEffect(() => {
    setZone1Answer('');
    setZone2Answer('');
    setResult('');
  }, [currentScene]);

  const checkAnswers = () => {
    const total = scene.count;
    const expected1 = Math.round((scene.zone1.percent / 100) * total);
    const expected2 = Math.round((scene.zone2.percent / 100) * total);

    const isZone1Correct = Number(zone1Answer) === expected1;
    const isZone2Correct = Number(zone2Answer) === expected2;

    const msg = [
      isZone1Correct
        ? `✅ ${scene.zone1.label} got ${zone1Answer} (${scene.zone1.percent}%) correct`
        : `❌ ${scene.zone1.label} should get ${expected1} (${scene.zone1.percent}%)`,
      isZone2Correct
        ? `✅ ${scene.zone2.label} got ${zone2Answer} (${scene.zone2.percent}%) correct`
        : `❌ ${scene.zone2.label} should get ${expected2} (${scene.zone2.percent}%)`,
      `🎯 Items left in jar: ${total - (Number(zone1Answer || 0) + Number(zone2Answer || 0))}`
    ];

    if (isZone1Correct && isZone2Correct) {
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }

    setResult(msg.join("\n"));
  };

  const nextScene = () => {
    setCurrentScene((prev) => (prev + 1) % scenes.length);
  };

  return (
    <div
      style={{
        fontFamily: "'Comic Sans MS', cursive",
        background: "linear-gradient(#fff3e0, #ffe0b2)",
        textAlign: "center",
        padding: "2rem 1rem",
        minHeight: "100vh",
        boxSizing: "border-box"
      }}
    >
      <h2 style={{ color: "#e65100", fontSize: "clamp(1.5rem, 5vw, 2.5rem)" }}>{scene.title}</h2>

      <div style={{ fontSize: "clamp(1rem, 3.5vw, 1.2rem)", marginBottom: "1rem" }}>
        <strong>Container has:</strong> {scene.count} items ({scene.emoji})
      </div>

      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "20px", marginBottom: "20px" }}>
        <div style={zoneInputStyle}>
          <label>{scene.zone1.label} ({scene.zone1.percent}%)</label>
          <input
            type="number"
            value={zone1Answer}
            onChange={(e) => setZone1Answer(e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={zoneInputStyle}>
          <label>{scene.zone2.label} ({scene.zone2.percent}%)</label>
          <input
            type="number"
            value={zone2Answer}
            onChange={(e) => setZone2Answer(e.target.value)}
            style={inputStyle}
          />
        </div>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <button onClick={checkAnswers} style={buttonStyle}>✅ Check</button>
        <button onClick={nextScene} style={buttonStyle}>➡ Next</button>
      </div>

      <div style={resultBox}>{result}</div>
      <div style={hintBox}>💡 Hint: {scene.hint}</div>
    </div>
  );
};

const zoneInputStyle = {
  border: "4px dashed #ff7043",
  borderRadius: "12px",
  backgroundColor: "#fffde7",
  minWidth: "140px",
  minHeight: "80px",
  padding: "20px",
  fontSize: "clamp(1rem, 2.5vw, 1.3rem)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

const inputStyle = {
  marginTop: "10px",
  padding: "10px",
  fontSize: "1.2rem",
  width: "80px",
  textAlign: "center",
  borderRadius: "8px",
  border: "2px solid #ff7043"
};

const buttonStyle = {
  padding: "12px 24px",
  margin: "10px",
  fontSize: "clamp(1rem, 3vw, 1.2rem)",
  border: "none",
  borderRadius: "10px",
  backgroundColor: "#ff7043",
  color: "white",
  cursor: "pointer",
  width: "min(180px, 80vw)"
};

const resultBox = {
  fontSize: "clamp(1rem, 3vw, 1.2rem)",
  fontWeight: "bold",
  marginTop: "20px",
  whiteSpace: "pre-line",
  maxWidth: "600px",
  marginInline: "auto"
};

const hintBox = {
  background: "#fff3e0",
  padding: "15px",
  borderRadius: "12px",
  fontSize: "clamp(1rem, 3vw, 1.2rem)",
  border: "2px solid #ffca28",
  maxWidth: "500px",
  margin: "2rem auto"
};

export default PercentFunParty;
